import { Box, styled } from '@mui/material';
import { ColorLabel } from '../../../../services/entities/impl/blfApi/schemas/stage';
import { getColorForColorLabel } from '../../../commonUI/getColorForColorLabel';

const BorderedCircleIcon = styled(Box)(({ theme }) => ({
  height: '1rem',
  width: '1rem',
  borderRadius: '50%',
  border: '1px solid',
  borderColor: theme.vars.palette.background.paper,
  margin: '-0.1875rem',
}));

type Props = {
  colors: ColorLabel[];
};

export const ColorSetIcon = ({ colors }: Props) => {
  if (colors.length === 0) {
    return <></>;
  }

  if (colors.length === 1) {
    return (
      <BorderedCircleIcon
        sx={{
          backgroundColor: getColorForColorLabel(colors[0]),
        }}
      />
    );
  }

  if (colors.length === 2) {
    return (
      <BorderedCircleIcon
        sx={{
          background: `linear-gradient(138deg, ${getColorForColorLabel(
            colors[0]
          )} 18%, ${getColorForColorLabel(colors[1])} 80%)`,
        }}
      />
    );
  }

  if (colors.length === 3) {
    return (
      <BorderedCircleIcon
        sx={{
          background: `linear-gradient(138deg, ${getColorForColorLabel(
            colors[0]
          )} 15%, ${getColorForColorLabel(
            colors[1]
          )} 57%, ${getColorForColorLabel(colors[2])} 87%)`,
        }}
      />
    );
  }

  return (
    <BorderedCircleIcon
      sx={{
        background: `linear-gradient(138deg,${colors.map(
          (color) => getColorForColorLabel(color) as string
        )})`,
      }}
    />
  );
};
